import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {UntypedFormGroup, AbstractControl, UntypedFormBuilder, Validators} from '@angular/forms';
import {slideInOutAnimation} from '../animations/router.animations';

import {CustomValidators} from 'ng2-validation';

import {User} from '../models/user.model';
import {BaseFormComponent} from '../../../shared/components/base-form.component';
import {Messages} from '../../../shared/constants/messages.constant';
import {LoginService} from '../services/login.service';
import {hasPermissionService} from "../../../shared/services/has.permission.service";
import {UserMessages} from '../constants/messages.constants';
import {NoOrganizationError} from '../models/user.errors';

@Component({
  selector: 'login',
  templateUrl: '../templates/login.html',
  styleUrls: ['../scss/login.scss'],
  animations: [slideInOutAnimation],
  host: {'[@slideInOutAnimation]': ''}
})
export class LoginComponent extends BaseFormComponent {

  user: User;
  errors: Array<string> = [];
  isUser: boolean = true;
  showLoading: boolean;
  errorAlert: boolean;

  constructor(private fb: UntypedFormBuilder,
              private router: Router,
              private loginService: LoginService,
              private permissionService: hasPermissionService) {
    super(
      {'email': '', 'password': ''},
      {
        'email': {
          'required': Messages.EMAIL_REQUIRED,
          'email': Messages.EMAIL_INVALID
        },
        'password': {
          'required': Messages.PASSWORD_REQUIRED
        }
      },
      fb
    );

    this.user = new User();
  }

  ngOnInit() {
    this.buildForm();
  }

  initializeForm(): UntypedFormGroup {
    return this.fb.group({
      'email': [this.user.email, Validators.compose([Validators.required, CustomValidators.email])],
      'password': [this.user.password, Validators.compose([Validators.required])]
    });
  }

  sendForm() {
    this.showLoading = true;
    let user = new User(null, null, this.form.value.email, this.form.value.password, null)
    return this.loginService
      .login(user)
      .subscribe(
        (res) => {
          this.loginSuccess(res)
        },
        (res) => {
          this.handleErrors(res)
        }
      );
  }

  loginSuccess(res) {
    this.showLoading = false;
    this.errors = [];
    const permissionLogin = this.permissionService.hasPermission('login_on_admin_dashboard');
    if (permissionLogin === false) {
      this.errors.push(UserMessages.PERMISSION_DENIED);
      localStorage.removeItem('user');
    } else {
      this.router.navigate(['pages/usuario']);
    }
  }

  handleErrors(errors: any) {
    this.showLoading = false;
    this.errors = [];
    let status = errors.status;
    if (status == 401) this.errors.push(UserMessages.CREDENTIALS_INVALID);
    else if (errors instanceof NoOrganizationError) this.errors.push(UserMessages.NO_ORGANIZATION);
    else if (!errors.data) this.errors.push('O usuário não tem permissão para logar no painel administrador.');
    else this.errors.push(UserMessages.GENERIC_ERROR);
  }
}
